import {
  UntypedFormBuilder,
  UntypedFormGroup,
  Validators,
} from '@angular/forms';
import { Component } from '@angular/core';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-my-stories',
  templateUrl: './my-stories.component.html',
})
export class MyStoriesComponent {
  addBrainstormForm: UntypedFormGroup = this.builder.group({
    brainstorm: ['', Validators.required],
  });

  inspirationList = [
    {
      index: 1,
      value: 'Favorite childhood vacation',
      color: 'rgb(77, 101, 141)',
    },
    {
      index: 2,
      value: 'Winning a major competition',
      color: 'rgb(17, 102, 17)',
    },
    {
      index: 3,
      value: 'The worst storm I ever been in',
      color: 'rgb(148, 33, 146)',
    },
  ];

  brainstorms: UntypedFormGroup[] = [];
  submit = false;

  constructor(private builder: UntypedFormBuilder) {}

  addBrainstorm() {
    const formControl = this.addBrainstormForm.controls;
    if (
      formControl.brainstorm.value !== '' &&
      !this.brainstorms.includes(formControl.brainstorm.value)
    ) {
      this.brainstorms.push(formControl.brainstorm.value);
    }
  }
  deleteBrainstorm(index: number) {
    Swal.fire({
      title: 'Are you sure?',
      text: `This action remove ${this.brainstorms[index]} from Brainstorms!`,
      icon: 'warning',
      showCancelButton: true,
      reverseButtons: true,
      customClass: {
        confirmButton: 'swal2-confirm',
        cancelButton: 'swal2-cancel',
        popup: 'swal2-custom',
      },
      confirmButtonText: 'Yes, Remove',
    }).then(result => {
      if (result.value) {
        this.brainstorms.splice(index, 1);
      }
    });
  }
  ngClassValidate(group: UntypedFormGroup, name: string): string {
    if (!this.submit) return '';
    return group.controls[name].errors ? 'is-invalid' : 'is-valid';
  }
}
